import React, { useEffect, useState } from "react";
import styles from "./css/AddCourseContentPage.module.css";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import IconTitle from "../../components/commons/IconTitle";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Button from "../../components/assignmentAndQuiz/Button/Button";
import ButtonMUI from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import MultipleSelectChip from "../AssignmentAndQuiz/Components/MultipleSelectChip";
import { handleErrorMessage } from "../../redux/actions/classes";
import { temp_sections } from "../AssignmentAndQuiz/temp_data";
import OuterSectionContainer from "./Components/OuterSectionContainer";
import LectureItem from "./Components/LectureItem";
import AddSectionLectureForm from "./Components/AddSectionLectureForm";
import { CircularProgress } from "@mui/material";
import {
  getCourseDetails,
  clearCourses,
  publishCourse,
} from "../../redux/actions/courses";
import ErrorFourZeroFour from "../../components/ErrorFourZeroFour";
import { GET_COURSE } from "../../redux/constants/actionTypes";
import { handleSuccessMessage } from "../../redux/actions/success";
import UpdateLectureComponent from "./Components/UpdateLectureComponent";

const AddCourseContentPage = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const courseID = params.id;
  const currentCourse = useSelector((state) => state?.courses?.currentCourse);
  const currentUser = currentCourse?.user_profile;
  const ownerId = currentCourse?.owner?.id;
  const canEdit = Boolean(currentUser && (currentUser?.id === ownerId ));
  const sections = currentCourse?.section;
  // const [sections, setSections] = useState([]);
  const [showAddSectionForm, setShowAddSectionForm] = useState(false);
  const [showUpdateLectureForm, setShowUpdateLectureForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [show404, setShow404] = useState(false);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [sectionEditData, setSectionEditData] = useState({
    id: null,
    title: "",
  });
  const [lectureEditData, setLectureEditData] = useState(null);
  const [courseData, setCourseData] = useState(currentCourse);

  useEffect(() => {
    setCourseData(currentCourse ?? null);
  }, [currentCourse]);

  const handleRemoveFromUI = (sectionID, lectureID, fileType) => {
  setCourseData((prev) => {
    if (!prev) return prev;
    const newSections = (prev.section || []).map((section) => {
      if (section.id !== sectionID) return section;

      if (fileType === "quiz") {
        return {
          ...section,
          quiz: (section.quiz || []).filter((q) => q.id !== lectureID),
        };
      } else {
        return {
          ...section,
          lectures: (section.lectures || []).filter((l) => l.id !== lectureID),
        };
      }
    });

    return {
      ...prev,
      section: newSections,
    };
  });
};

  useEffect(() => {
    if (!currentCourse?.id) {
      setIsLoading(true);
      dispatch(getCourseDetails(courseID)).then(() => setIsLoading(false));
    }
    console.log(courseID, currentCourse?.id);
  }, [!currentCourse?.id]);

  const handleSave = () => {
    if (!canEdit) {
      dispatch(handleErrorMessage(t("courseMonetisation.notAllowed")));
      return;
    }
    // NO API CALL ON SAVE BUTTON, ONLY REDIRECT
    dispatch(handleSuccessMessage(t("courseMonetisation.courseSaved")));
    history.push(`/courses`);
  };

  const handlePublish = () => {
    if (!canEdit) {
      dispatch(handleErrorMessage(t("courseMonetisation.notAllowed")));
      return;
    }
    setIsLoadingBtn(true);
    let hasEmptyLectureArray = currentCourse?.section?.some((section) => {
      return section.lectures?.length < 1;
    });

    // if (hasEmptyLectureArray) {
    //   setIsLoadingBtn(false);
    //   dispatch(handleErrorMessage(t("courseMonetisation.cantPublish")));
    // } else {
    setIsLoadingBtn(false);
    dispatch(publishCourse(courseID));
    history.push({
      pathname: `/courses`,
      state: { switchSection: "course" },
    });
    // }
  };

  const handleTitleEdit = (id, title) => {
    setIsEditing(true);
    setShowAddSectionForm(true);
    setSectionEditData({ id: id, title: title });
  };

  const handleEditLecture = (sectionID, lectureData) => {
    const data = { ...lectureData };
    data.sectionID = sectionID;
    setIsEditing(true);
    setShowUpdateLectureForm(true);
    setLectureEditData(data);
  };

  // const handleEditQuiz = (sectionID, quizData) => {
  //   history.push({
  //     pathname: `/quiz/create/${courseID}`, 
  //     state: {
  //       isEditing: true,
  //       quiz: quizData,
  //       sectionId: sectionID,
  //     },
  //   });
  //   return;
  // };

  // useEffect(() => {
  //   if (currentCourse?.id) {
  //     localStorage.setItem("currentCourse", JSON.stringify(currentCourse));
  //     setIsLoading(false);
  //   }
  // }, [currentCourse]);

  // useEffect(() => {
  //   if (!currentCourse) {
  //     const course = JSON.parse(localStorage.getItem("currentCourse")) ?? null;
  //     if (!course) {
  //       setIsLoading(false);
  //       setShow404(true);
  //     } else {
  //       // dispatch(getCourseDetails(course?.id)).then(() => setIsLoading(false));
  //       console.log('inside else')

  //       dispatch({
  //         type: "GET_COURSE",
  //         payload: course, // Payload
  //       })
  //     }
  //   }
  // });

  // useEffect(() => {
  //   return () => {
  //     localStorage.removeItem("currentCourse");
  //     dispatch(clearCourses());
  //   };
  // }, []);

  const styleAddIcon = {
    "@media (max-width: 500px)": {
      width: "13px",
      height: "13px",
    },
  };

  const styleButtonMUI = {
    display: "flex",
    alignItems: "center",
    borderRadius: "10px",
    backgroundColor: "#F33070",
    borderColor: "#F33070",
    textTransform: "none",
    color: "#fff",
    // boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;",
    marginRight: "auto",
    "&:hover": {
      backgroundColor: "#fff",
      borderColor: "#F33070",
      color: "#F33070",
      boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;",
    },
    "&.Mui-disabled": {
      backgroundColor: "#A6A6A6",
      color: "#FFF",
      border: "none",
    },
    "@media (max-width: 500px)": {
      height: "25px",
      padding: "6.756px 6.647px 8px 10px",
    },
  };

  if (isLoading) {
    return (
      <div className={styles.loader_style}>
        <CircularProgress sx={{ color: "#F33070" }} size={50} />
      </div>
    );
  } else if (show404) {
    return <ErrorFourZeroFour />;
  } else {
    return (
      <div className={styles.main}>
        {/* LEFT CONTAINER */}
        <div className={styles.left_container}>
          <div className={styles.thumbnail_container}>
            <img
              src={
                currentCourse?.thumbnail ??
                "/Image/CourseMonitization/CourseViewBanner.png"
              }
              alt="course-thumbnail"
            />
          </div>

          <IconTitle
            title={currentCourse?.name}
            img="/Image/CourseMonetisation/booklet-line-2.svg"
            notClickable={true}
            type="ASSIGNMENT"
          />

          {/* <div className={styles.courseType}>
            <span className={styles.course_type_label}>
              {t("courseMonetisation.courseType")}:
            </span>
            <span className={styles.course_type_span}>
              {t(
                `${currentCourse?.public ? "common.Public" : "common.Private"}`
              )}
            </span>
          </div> */}

          {currentCourse?.classes?.length > 0 && (
            <>
              <span className={styles.input_label}>
                {t("courseMonetisation.publishingTo")}
              </span>
              <div className={styles.inputTags}>
                <Stack direction="row" spacing={0.4}>
                  {currentCourse?.classes.map((item) => (
                    <Chip
                      key={item?.id}
                      label={item?.name}
                      variant="outlined"
                      style={{
                        backgroundColor: "#F33070",
                        border: "none",
                        color: "#FFFFFF",
                        fontWeight: "700",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        textTransform: "capitalize",
                      }}
                    />
                  ))}
                </Stack>
              </div>
            </>
          )}

          <span className={styles.input_label}>
            {t("createCourse.courseSubtitle")}
          </span>
          <span className={styles.subtext}>{currentCourse?.subtitle}</span>

          {currentCourse?.prerequisites?.length > 0 && (
            <>
              <span className={styles.input_label}>
                {t("courseMonetisation.prerequisites")}
              </span>
              <ul className={styles.info_list}>
                {currentCourse.prerequisites.map((p, idx) => (
                  <li key={idx}>{p}</li>
                ))}
              </ul>
            </>
          )}

          {currentCourse?.learning_outcomes?.length > 0 && (
            <>
              <span className={styles.input_label}>
                {t("courseMonetisation.learning_outcomes")}
              </span>
              <ul className={styles.info_list}>
                {currentCourse.learning_outcomes.map((lo, idx) => (
                  <li key={idx}>{lo}</li>
                ))}
              </ul>
            </>
          )}

          <span className={styles.input_label}>
            {t("courseMonetisation.courseLevel")}
          </span>
          <span className={styles.subtext}>
            {(() => {
              const v = currentCourse?.course_level ?? "All";
              return typeof v === "string" && v.length
                ? v.charAt(0).toUpperCase() + v.slice(1)
                : v;
            })()}
          </span>

          {currentCourse?.tags?.length > 0 && (
            <>
              <span className={styles.input_label}>{t("courseMonetisation.tags")}</span>

              <div className={styles.tags_row}>
                <Stack
                  direction="row"
                  spacing={0.4}
                  sx={{ flexWrap: 'wrap', width: '100%' }}    // <-- ensure wrap on the Stack
                >
                  {currentCourse.tags.map((tag, i) => (
                    <Chip
                      key={i}
                      label={tag}
                      variant="outlined"
                      className={styles.tag_chip}
                      size="small"
                    />
                  ))}
                </Stack>
              </div>
            </>
          )}

          <span className={styles.input_label}>
            {t("courseMonetisation.description")}
          </span>
          <span className={styles.subtext}>{currentCourse?.description}</span>

        </div>

        {/* -------------RIGHT CONTAINER--------- */}

        <div className={styles.right_container}>
          <span className={styles.add_content_label}>
            {t("courseMonetisation.addContent")}
          </span>

          {courseData?.section?.length > 0 &&
            courseData.section.map((section, sectionIndex) => (
              <OuterSectionContainer
                key={section.id}
                index={sectionIndex}
                title={section.title}
                sectionID={section.id}
                isEditing={isEditing}
                canEdit={canEdit}
                onEdit={canEdit ? handleTitleEdit : dispatch(handleErrorMessage(t("courseMonetisation.notAllowed")))}
                showUpdateLectureForm={showUpdateLectureForm}
                lectureEditData={lectureEditData}
                onCancelLectureUpdate={() => {
                  setIsEditing(false);
                  setShowUpdateLectureForm(false);
                  setLectureEditData(null);
                }}
                onLectureContentUpdate={() => {
                  setShowUpdateLectureForm(false);
                }}
              >
                {section?.lectures?.length > 0 &&
                  section.lectures.map((lecture, lectureIndex) => (
                    <LectureItem
                      key={lecture?.id}
                      sectionID={section.id}
                      lectureID={lecture.id}
                      index={lectureIndex}
                      title={lecture?.title}
                      fileType={lecture?.fileType}
                      isEditing={isEditing}
                      onEdit={canEdit ? handleEditLecture : undefined}
                      lecture={lecture}
                      onDelete={canEdit ? handleRemoveFromUI : undefined}
                    />
                  ))}

                {section?.quiz?.length > 0 &&
                  section.quiz.map((quiz, quizIndex) => (
                    <LectureItem
                      key={quiz?.id}
                      index={quizIndex}
                      title={quiz?.title}
                      fileType={"quiz"}
                      lecture={quiz}
                      sectionID={section.id}
                      lectureID={quiz?.id}
                      onDelete={canEdit ? handleRemoveFromUI : undefined}
                    />
                  ))}
                {/* <ButtonMUI
                variant="outlined"
                startIcon={<AddIcon />}
                disableRipple
                onClick={() => setShowAddLectureForm(true)}
                sx={styleButtonMUI}
              >
                <span className={styles.btn_label}>
                  {t("courseMonetisation.curriculumItem")}
                </span>
              </ButtonMUI> */}
              </OuterSectionContainer>
            ))}

          {canEdit && (
            <ButtonMUI
              variant="outlined"
              startIcon={<AddIcon sx={styleAddIcon} />}
              disableRipple
              disabled={showAddSectionForm || isEditing}
              onClick={() => setShowAddSectionForm(true)}
              sx={styleButtonMUI}
            >
              <span className={styles.btn_label}>{t("common.section")}</span>
            </ButtonMUI>
          )}
          {showAddSectionForm && canEdit && (
            <AddSectionLectureForm
              isSection={true}
              courseID={courseID}
              onCancel={() => {
                setShowAddSectionForm(false);
                setIsEditing(false);
                setSectionEditData({});
              }}
              isEditing={isEditing}
              sectionID={sectionEditData.id}
              lectureID={sectionEditData.id}
              title={sectionEditData.title}
            />
          )}

          {showUpdateLectureForm && canEdit && (
            <UpdateLectureComponent
              lecture={lectureEditData}
              onCancel={() => {
                setIsEditing(false);
                setShowUpdateLectureForm(false);
                setLectureEditData(null);
              }}
            />
          )}

          <div className={styles.btn_div}>
            <Button
              type="outlined"
              label={t("assignment.save")}
              disable={currentCourse?.section?.length < 1}
              clickHandler={handleSave}
            />
            <Button
              type="solid"
              // label={t("common.publish")}
              label={
                isLoadingBtn ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  t("common.publish")
                )
              }
              disable={currentCourse?.section?.length < 1}
              clickHandler={handlePublish}
            />
          </div>
        </div>
      </div>
    );
  }
};

export default AddCourseContentPage;
